import { constant } from "react-cas-client";

export let casEndpoint = process.env.REACT_APP_CAS_URL;

export let casOptions = {
  version: constant.CAS_VERSION_2_0,
};
